module.exports = __webpack_public_path__ + "static/img/bg-1.cf779f9e.png";